import { jsx, jsxs } from 'react/jsx-runtime';
import { Content, ContentHeader, SupportButton } from '@backstage/core-components';
import { EntityListProvider, CatalogFilterLayout, UserListPicker, EntityOwnerPicker, EntityTagPicker } from '@backstage/plugin-catalog-react';
import { TechDocsPageWrapper } from './TechDocsPageWrapper.esm.js';
import { TechDocsPicker } from './TechDocsPicker.esm.js';
import { EntityListDocsTable } from './Tables/EntityListDocsTable.esm.js';
import './Tables/DocsTable.esm.js';

const DefaultTechDocsHome = (props) => {
  const {
    initialFilter = "owned",
    columns,
    actions,
    ownerPickerMode,
    pagination,
    options,
    PageWrapper,
    CustomHeader
  } = props;
  const Wrapper = PageWrapper ? PageWrapper : TechDocsPageWrapper;
  const Header = CustomHeader || (() => /* @__PURE__ */ jsx(ContentHeader, { title: "", children: /* @__PURE__ */ jsx(SupportButton, { children: "Discover documentation in your ecosystem." }) }));
  return /* @__PURE__ */ jsx(Wrapper, { children: /* @__PURE__ */ jsxs(Content, { children: [
    /* @__PURE__ */ jsx(Header, {}),
    /* @__PURE__ */ jsx(EntityListProvider, { pagination, children: /* @__PURE__ */ jsxs(CatalogFilterLayout, { children: [
      /* @__PURE__ */ jsxs(CatalogFilterLayout.Filters, { children: [
        /* @__PURE__ */ jsx(TechDocsPicker, {}),
        /* @__PURE__ */ jsx(UserListPicker, { initialFilter }),
        /* @__PURE__ */ jsx(EntityOwnerPicker, { mode: ownerPickerMode }),
        /* @__PURE__ */ jsx(EntityTagPicker, {})
      ] }),
      /* @__PURE__ */ jsx(CatalogFilterLayout.Content, { children: /* @__PURE__ */ jsx(
        EntityListDocsTable,
        {
          actions,
          columns,
          options
        }
      ) })
    ] }) })
  ] }) });
};

export { DefaultTechDocsHome };
//# sourceMappingURL=DefaultTechDocsHome.esm.js.map
